import React from 'react';
import { Link } from "react-router-dom";
import TopNavigation from './TopNavigation';
import Footer from './Footer';
import logoStacked from './img/logo-complex-boss-mobile.png';
import logoHorizontal from './img/logo-complex-boss-desktop.png';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import paulanaLamonier320 from './img/paulana-lamonier-320.jpg';
import paulanaLamonier640 from './img/paulana-lamonier-640.jpg';
import paulanaLamonier960 from './img/paulana-lamonier-960.jpg';
import bimmaWilliams320 from './img/bimma-williams-320.jpg';
import bimmaWilliams640 from './img/bimma-williams-640.jpg';
import bimmaWilliams960 from './img/bimma-williams-960.jpg';
import bruceHamilton320 from './img/bruce-hamilton-320.jpg';
import bruceHamilton640 from './img/bruce-hamilton-640.jpg';
import bruceHamilton960 from './img/bruce-hamilton-960.jpg';
import anishaMatharuAndSabrinaMoin320 from './img/anisha-matharu-and-sabrina-moin-320.jpg';
import anishaMatharuAndSabrinaMoin640 from './img/anisha-matharu-and-sabrina-moin-640.jpg';
import anishaMatharuAndSabrinaMoin960 from './img/anisha-matharu-and-sabrina-moin-960.jpg';

gsap.registerPlugin(ScrollTrigger);


class Participants extends React.Component {
    // constructor(props: any) {
    //     super(props);
    // }

    componentDidMount() {
        var animatedItems = document.querySelectorAll('[data-animation]');

        var animatedItemsOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.7,
        };

        var animatedItemsCallback = function(entries: any, observer: any) {
            entries.forEach(function(entry: any) {
                if (entry.intersectionRatio > 0) {
                    const animationClasses = entry.target.dataset.animation.split(' ');
                    animationClasses.forEach((animationClass: string) => {
                        entry.target.classList.add(animationClass);
                    });
                    entry.target.classList.add('animate__animated');
                }
            });
        };

        var animatedItemsObserver = new IntersectionObserver(animatedItemsCallback, animatedItemsOptions);
        animatedItems.forEach(function(item){
            animatedItemsObserver.observe(item);
        });

        ScrollTrigger.create({
            trigger: '#header',
            id: 'header',
            start: 'top top+=20',
            end: () => `${document.body.clientHeight}`,
            toggleActions: 'play reverse none reverse',
            toggleClass: {
                targets: '#header',
                className: "sticky"
            },
            // markers: true
        });
    }

    render() {
        return (
            <React.Fragment>
                <section id="participants">
                    <div className="wrapper">
                        <div className="top-wrapper">
                            <TopNavigation />

                            <header id="header">
                                <Link to="/" className="header__wrapper">
                                    <img className="logo logo--stacked" src={logoStacked} alt="logo stacked" />
                                    <img className="logo logo--horizontal" src={logoHorizontal} alt="logo horizontal" />
                                    <p className="header__heading">BIPOC OWNERS WITH SUCCESS-BASED SERVICES</p>
                                </Link>
                            </header>

                            <h1 className="section-heading" data-animation="animate__fadeInDown">2021 Participants</h1>
                        </div>

                        <ul className="participants__list">
                            <li className="participant__item" data-animation="animate__fadeInDown">
                                <img className="participant__image"
                                     src={paulanaLamonier320} alt="Paulana Lamonier"
                                     srcSet={`${paulanaLamonier320} 1x, ${paulanaLamonier640} 2x, ${paulanaLamonier960} 3x`} />

                                <div className="participant-item__body">
                                    <h3 className="participant__heading">BLACK PEOPLE WILL SWIM</h3>

                                    <footer className="participant__details">
                                        <p><span className="participant-detail__label">Founder:</span> Paulana Lamonier</p>
                                        <p><span className="participant-detail__label">Base of Operations:</span> New York, NY</p>
                                        <p><span className="participant-detail__label">Website:</span> <a href="https://blackpeoplewillswim.com" target="_blank" rel="noopener noreferrer">BlackPeopleWillSwim.com</a></p>
                                    </footer>
                                </div>
                            </li>

                            <li className="participant__item d100" data-animation="animate__fadeInDown">
                                <img className="participant__image"
                                     src={bimmaWilliams320} alt="Bimma Williams"
                                     srcSet={`${bimmaWilliams320} 1x, ${bimmaWilliams640} 2x, ${bimmaWilliams960} 3x`} />

                                <div className="participant-item__body">
                                    <h3 className="participant__heading">CLAIMA STORIES</h3>

                                    <footer className="participant__details">
                                        <p><span className="participant-detail__label">Founder:</span> Bimma Williams</p>
                                        <p><span className="participant-detail__label">Base of Operations:</span> Portland, OR </p>
                                        <p><span className="participant-detail__label">Website:</span> <a href="https://claimastories.com" target="_blank" rel="noopener noreferrer">ClaimaStories.com</a></p>
                                    </footer>
                                </div>
                            </li>

                            <li className="participant__item d200" data-animation="animate__fadeInDown">
                                <img className="participant__image"
                                     src={bruceHamilton320} alt="Bruce Hamilton"
                                     srcSet={`${bruceHamilton320} 1x, ${bruceHamilton640} 2x, ${bruceHamilton960} 3x`} />

                                <div className="participant-item__body">
                                    <h3 className="participant__heading">WING ZERO APPS</h3>

                                    <footer className="participant__details">
                                        <p><span className="participant-detail__label">Founder:</span> Bruce Hamilton</p>
                                        <p><span className="participant-detail__label">Base of Operations:</span> Los Angeles, CA</p>
                                        <p><span className="participant-detail__label">Website:</span> <a href="https://wingzeroapps.com" target="_blank" rel="noopener noreferrer">WingZeroApps.com</a></p>
                                    </footer>
                                </div>
                            </li>

                            <li className="participant__item d300" data-animation="animate__fadeInDown">
                                <img className="participant__image"
                                     src={anishaMatharuAndSabrinaMoin320} alt="Anisha Matharu and Sabrina Moin"
                                     srcSet={`${anishaMatharuAndSabrinaMoin320} 1x, ${anishaMatharuAndSabrinaMoin640} 2x, ${anishaMatharuAndSabrinaMoin960} 3x`} />

                                <div className="participant-item__body">
                                    <h3 className="participant__heading">SWATCHCANDY</h3>

                                    <footer className="participant__details">
                                        <p><span className="participant-detail__label">Founder:</span> Anisha Matharu &amp;
Sabrina Moin</p>
                                        <p><span className="participant-detail__label">Base of Operations:</span> Atlanta, GA</p>
                                        <p><span className="participant-detail__label">Website:</span> <a href="https://swatchcandy.com" target="_blank" rel="noopener noreferrer">Swatchcandy.com</a></p>
                                    </footer>
                                </div>
                            </li>
                        </ul>

                        <a className="questions-contact d400" href="https://www.complex.com/life/boss-mentorship-program-lets-minority-entrepreneurs-shine/" target="_blank" rel="noopener noreferrer" data-animation="animate__fadeInDown">
                        Read more about these participants as well as honorable mentions at <span className="pseudolink">Complex.com.</span>
                        </a>

                    </div>{/* wrapper */}
                </section>

                <Footer />
            </React.Fragment>
        );
    }
}

export default Participants;
